<template lang="pug">
    main.main
        svg(aria-hidden='true', style='position: absolute; width: 0; height: 0; overflow: hidden;', version='1.1', xmlns='http://www.w3.org/2000/svg', xmlns:xlink='http://www.w3.org/1999/xlink')
            symbol(id='main', viewBox='0 0 21.13 35.46')
                title На главную
                path(d='M21.13 35.46l-5.37-19.12a9 9 0 1 0-10.39 0L0 35.46z')
            symbol(id='menu', viewBox='0 0 36 21.85')
                title Меню
                path(d='M0 0v3.51h36V0H0zM0 9.17v3.51h36V9.17H0zM0 18.34v3.51h36v-3.51H0z')
            symbol(id='close', viewBox='0 0 357 357')
                title Закрыть
                path(d='M357 35.7L321.3 0 178.5 142.8 35.7 0 0 35.7l142.8 142.8L0 321.3 35.7 357l142.8-142.8L321.3 357l35.7-35.7-142.8-142.8z')
            symbol(id='cross', viewBox='0 0 138.16 138.16')
                path(fill='none', stroke-miterlimit='10', d='M136.74 20.74L117.42 1.41 69.08 49.75 20.74 1.41 1.41 20.74l48.34 48.34-48.34 48.34 19.33 19.32 48.34-48.33 48.34 48.33 19.32-19.32-48.33-48.34 48.33-48.34z')
            symbol(id='arrow-top', viewBox='0 0 81.7 99.9')
                title arrow top
                path(fill='none', stroke-miterlimit='10', d='M51 10.7l-3-3L40.8.5l-7.2 7.2-3 3L.7 40.6l10.2 10.2 22.7-22.7v71.1H48V28.1l22.8 22.7 10.1-10.2z')
            symbol(id='arrow-right', viewBox='0 0 138.21 112.75')
                title arrow right
                path(fill='none', stroke-miterlimit='10', d='M81.82.71L67.68 14.85l31.53 31.53H.5v20h98.71L67.68 97.91l14.14 14.14 41.53-41.53.02.02 4.15-4.16 9.98-9.98.01-.01h-.01v-.02l.01-.01-.01-.01-9.98-9.97-4.15-4.16-.02.01L81.82.71z')
            symbol(id='arrow-bottom', viewBox='0 0 112.75 138.21')
                title arrow bottom
                path(fill='none', stroke-miterlimit='10', d='M112.05 81.82L97.91 67.68 66.38 99.21V.5h-20v98.71L14.85 67.68.71 81.82l41.52 41.53-.01.02 4.16 4.15 9.97 9.98.01.01.01-.01h.02v.01l.01-.01 9.98-9.98 4.16-4.15-.02-.02 41.53-41.53z')
            symbol(id='arrow-left', viewBox='0 0 138.21 112.75')
                title arrow left
                path(fill='none', stroke-miterlimit='10', d='M56.39 112.05l14.15-14.14-31.53-31.53h98.71v-20H39.01l31.53-31.53L56.39.71 14.87 42.23l-.02-.01-4.16 4.16-9.98 9.97v.05l9.98 9.98 4.16 4.16.02-.02 41.52 41.53z')
            symbol(id='lenta', viewBox='0 0 90.15 14.97')
                title lenta
                path(d='M0,14.64V.33H3.08V11.88H8v2.76H0M14.64,15c2.37,0,4-.33,5-1.06V11a6.52,6.52,0,0,1-4.43,1.48c-1.55,0-3.52-.48-3.52-1.91,0-2.18,2.29-2.27,5-2.27h.37V5.92h-.5c-2.71,0-4.43-.2-4.43-1.69,0-1.3,1.06-1.7,2.45-1.7a5.68,5.68,0,0,1,3.56.93V.64A8.51,8.51,0,0,0,14.64,0C11.55,0,9.11,1.19,9.11,4.09a2.84,2.84,0,0,0,2.27,3,3.41,3.41,0,0,0-2.77,3.48C8.61,13.78,11.31,15,14.64,15ZM31,.33V8.69L21.46,0h-.13V14.64h3.08V6.58L33.94,15h.13V2.86h4.64V14.64h3.08V2.86h4.74V.33ZM55.43,14.64h3.3L51.12,0H51l-7.4,14.64h3.3L48,12.26h6.32ZM51.05,5.52l2.07,4.32h-4Zm8.8,7.72a1.72,1.72,0,1,0,3.43,0,1.72,1.72,0,0,0-3.43,0ZM65,14.64h3.08V11.51h1.45a6.68,6.68,0,0,0,1.21-.09l2.84,3.22h3.63L73.52,10.3a5.4,5.4,0,0,0,2.14-4.38c0-3.61-2.29-5.59-6.1-5.59H65ZM68.11,2.86h1.17c2.2,0,3.3,1.12,3.3,3.06A3,3,0,0,1,69.25,9H68.11Zm15.8,9.57c-2,0-3.17-1.42-3.17-4.56V.33H77.66V7.19c0,4.77,1.7,7.78,6.25,7.78s6.24-3.07,6.24-7.78V.33H87.07V7.87C87.07,11,85.87,12.43,83.91,12.43Z')
            symbol(id='turnoff', viewBox='0 0 28.57 25.26')
                title turnoff
                path(d='M15.6.22a1.69 1.69 0 0 0-1.7 0l-.07.08-7.44 6.29H.55a.55.55 0 0 0-.55.55v10.43a.55.55 0 0 0 .16.43.51.51 0 0 0 .39.16h5.83L13.81 25l.09.07a1.7 1.7 0 0 0 .87.24 1.66 1.66 0 0 0 .83-.31 1.71 1.71 0 0 0 .88-1.51V1.73A1.72 1.72 0 0 0 15.6.22zm-.22 23.31a.63.63 0 0 1-.32.56.56.56 0 0 1-.55 0l-7.37-6.76v-2.5a.55.55 0 1 0-1.1 0V17H1.1V7.69H6v2.2a.55.55 0 0 0 1.1 0V7.4l7.4-6.23a.56.56 0 0 1 .56 0 .62.62 0 0 1 .32.55zM21.31 2.23a.55.55 0 0 0-.7.34.55.55 0 0 0 .34.7 9.6 9.6 0 0 1 0 18.18.55.55 0 0 0 .17 1.07.57.57 0 0 0 .18 0 10.7 10.7 0 0 0 0-20.26z')
                path(d='M23.63 12.36a7.45 7.45 0 0 0-5.35-7.12.54.54 0 0 0-.68.37.54.54 0 0 0 .37.68 6.31 6.31 0 0 1 0 12.13.54.54 0 0 0-.37.68.53.53 0 0 0 .52.4h.16a7.46 7.46 0 0 0 5.35-7.14z')
            symbol(id='turnon', viewBox='0 0 29.66 25.26')
                title turnon
                path(d='M25.49 12.08l4-4a.54.54 0 0 0 0-.78.55.55 0 0 0-.77 0l-4 4-4-4a.55.55 0 1 0-.78.78l4 4-4 4a.55.55 0 0 0 0 .77.53.53 0 0 0 .78 0l4-4 4 4a.56.56 0 0 0 .39.17.52.52 0 0 0 .38-.17.53.53 0 0 0 0-.77zM15.6.22a1.69 1.69 0 0 0-1.7 0l-.07.08-7.44 6.29H.55a.55.55 0 0 0-.55.55v10.43a.55.55 0 0 0 .16.43.51.51 0 0 0 .39.16h5.83L13.81 25l.09.07a1.7 1.7 0 0 0 .87.24 1.66 1.66 0 0 0 .83-.31 1.71 1.71 0 0 0 .88-1.51V1.73A1.72 1.72 0 0 0 15.6.22zm-.22 23.31a.63.63 0 0 1-.32.56.56.56 0 0 1-.55 0l-7.37-6.76v-2.5a.55.55 0 1 0-1.1 0V17H1.1V7.69H6v2.2a.55.55 0 0 0 1.1 0V7.4l7.4-6.23a.56.56 0 0 1 .56 0 .62.62 0 0 1 .32.55z')
            symbol(id='quality', viewBox='0 0 117.78 10.03')
                title quality
                path(d='M1.53.21h4C8.06.21 8.27 1.88 8.08 3a3.21 3.21 0 0 1-3.53 2.76H2.16l-.59 3.46H0zm.85 4.27h2.3A1.76 1.76 0 0 0 6.51 3c.2-1.2-.51-1.5-1.3-1.5H2.88zM9.93.21h4.29c2 0 2.82.91 2.56 2.44a2.7 2.7 0 0 1-1.87 2.27c.53.07 1.25.49 1 1.91A3.79 3.79 0 0 0 16 9.22h-1.68a2.4 2.4 0 0 1 0-1.33c.28-1.65.06-2.38-1.39-2.38h-2.32L10 9.22H8.4zm.88 4.1h2.58a1.6 1.6 0 0 0 1.78-1.44c.2-1.16-.51-1.37-1.33-1.37h-2.55zM18.8.21h6.47L25 1.58h-4.9l-.4 2.35h4.53l-.21 1.29h-4.5l-.44 2.63h5l-.23 1.37h-6.58zM26.71.21h2.22l1.28 7.05 3.61-7H36l-1.53 9H33l1.18-7-3.67 7H29.2l-1.31-7-1.18 7h-1.5zM37.93.21h1.58L38 9.22h-1.59zM41.34.21h1.57L42 5.46c-.21 1.21-.37 2.61 1.67 2.61s2.36-1.4 2.56-2.61l.91-5.25h1.57L47.74 6a4 4 0 0 1-4.28 3.45C41.25 9.43 40 8.28 40.36 6zM50.51.21h2.21L54 7.26l3.61-7h2.2l-1.53 9h-1.5l1.18-7-3.67 7H53l-1.31-7-1.18 7H49zM71.73 9.18l-.91.85-1.12-1.14a4.67 4.67 0 0 1-2.2.54c-2.69 0-4-2.13-3.51-4.72A5.36 5.36 0 0 1 69.1 0c2.68 0 3.9 2.16 3.5 4.71a5.69 5.69 0 0 1-1.86 3.46zM68 7.14l.9-.87.93 1A4.56 4.56 0 0 0 71 4.71c.29-1.72-.22-3.42-2.15-3.42s-3 1.7-3.32 3.42.23 3.43 2.15 3.43a2.62 2.62 0 0 0 1.05-.21zM74.71.21h1.57l-.89 5.25c-.21 1.21-.37 2.61 1.67 2.61s2.36-1.4 2.56-2.61l.89-5.25h1.57L81.11 6a4 4 0 0 1-4.28 3.45c-2.21 0-3.49-1.15-3.1-3.45zM86.31.21H88l1.94 9h-1.71l-.44-2.39H84.2L83 9.22h-1.67zm-1.48 5.43h2.75l-.69-3.87zM92.3.21h1.58l-1.3 7.64h4.57l-.23 1.37h-6.14zM99.54.21h1.57l-1.53 9H98zM102.18.21h7.28l-.23 1.37h-2.86l-1.3 7.64h-1.57l1.3-7.64H102zM111.92 5.69L109.48.21h1.82l1.7 4 3-4h1.76l-4.29 5.48-.59 3.53h-1.58z')
            symbol(id='ntsc', viewBox='0 0 29.87 9')
                title ntsc
                path(d='M0 8.85V.15h1.18L5.75 7V.15h1.11v8.7H5.68L1.1 2v6.85zM10.4 8.85V1.18H7.53v-1h6.9v1h-2.88v7.67zM14.61 6.06L15.7 6a2.34 2.34 0 0 0 .36 1 1.91 1.91 0 0 0 .87.68 3.37 3.37 0 0 0 1.34.32 3.2 3.2 0 0 0 1.16-.2 1.56 1.56 0 0 0 .75-.54 1.18 1.18 0 0 0 .25-.74 1.16 1.16 0 0 0-.24-.72 1.82 1.82 0 0 0-.78-.51 16 16 0 0 0-1.55-.42 8.31 8.31 0 0 1-1.68-.55 2.34 2.34 0 0 1-.93-.81 2 2 0 0 1-.31-1.08 2.2 2.2 0 0 1 .38-1.23 2.22 2.22 0 0 1 1.09-.9A4.11 4.11 0 0 1 18 0a4.3 4.3 0 0 1 1.7.31 2.39 2.39 0 0 1 1.14.92 2.58 2.58 0 0 1 .43 1.37l-1.11.08a1.77 1.77 0 0 0-.6-1.24A2.35 2.35 0 0 0 18.05 1a2.41 2.41 0 0 0-1.52.38 1.13 1.13 0 0 0-.48.92 1 1 0 0 0 .34.77 4.57 4.57 0 0 0 1.74.62 11.82 11.82 0 0 1 1.92.56 2.6 2.6 0 0 1 1.13.89 2.14 2.14 0 0 1 .36 1.23 2.32 2.32 0 0 1-.4 1.31 2.59 2.59 0 0 1-1.14 1 4 4 0 0 1-1.68.32 5.17 5.17 0 0 1-2-.34 2.78 2.78 0 0 1-1.25-1 3 3 0 0 1-.46-1.6zM28.71 5.8l1.16.29a3.81 3.81 0 0 1-1.31 2.16 3.55 3.55 0 0 1-2.3.75A4.16 4.16 0 0 1 24 8.43a3.66 3.66 0 0 1-1.34-1.66 6.06 6.06 0 0 1-.46-2.34 5.24 5.24 0 0 1 .52-2.37A3.59 3.59 0 0 1 24.17.53 4.21 4.21 0 0 1 26.28 0a3.55 3.55 0 0 1 2.2.67 3.48 3.48 0 0 1 1.24 1.86l-1.14.27a2.7 2.7 0 0 0-.87-1.38A2.35 2.35 0 0 0 26.26 1a2.83 2.83 0 0 0-1.68.48 2.52 2.52 0 0 0-.95 1.29 5.22 5.22 0 0 0-.27 1.67 5.48 5.48 0 0 0 .32 1.94 2.44 2.44 0 0 0 1 1.23 2.75 2.75 0 0 0 1.49.39 2.5 2.5 0 0 0 1.64-.55 2.89 2.89 0 0 0 .9-1.65z')

        router-view

        vue-progress-bar

        Updated

        .controls(:data-chapter='currentRoute')
            Share
            Audio

</template>

<script>
/* https://github.com/chris-pearce/backpack.css */
import 'backpack.css';

/* meta info (for title) */
import meta from '@/assets/data/meta';

/* 'new content available' badge */
const Updated = () => import('@/components/Updated.vue');

/* music and share on page */
const Share = () => import('@/components/Share.vue');
const Audio = () => import('@/components/Audio.vue');

export default {
    name: 'App',

    metaInfo: {
        titleTemplate: titleChunk => {
            return titleChunk ? `${titleChunk} - ${meta.title}` : meta.title;
        }
    },

    components: {
        Updated,
        Share,
        Audio
    },

    computed: {
        currentRoute() {
            return this.$route.path.replace('/', '');
        }
    },

    created() {
        this.progressOnRouting();

        this.removeLoadingClass();
    },

    mounted() {
        this.$Progress.finish();

        this.calculateVH();
    },

    methods: {
        progressOnRouting() {
            this.$Progress.start();

            this.$router.beforeEach((to, from, next) => {
                this.$Progress.start();
                next();
            });

            this.$router.afterEach(() => {
                this.$Progress.finish();
            });
        },

        removeLoadingClass() {
            const listener = () => {
                document.body.classList.remove('js-loading');
                window.removeEventListener('load', listener);
            };
            window.addEventListener('load', listener);
        },

        calculateVH() {
            const setVH = () => {
                const vh = window.innerHeight * 0.01;
                document.documentElement.style.setProperty('--vh', `${vh}px`);
            };

            setVH();

            /* resize */
            (function() {
                const throttle = function(type, name, obj) {
                    obj = obj || window;
                    let running = false;
                    const func = function() {
                        if (running) {
                            return;
                        }
                        running = true;
                        requestAnimationFrame(function() {
                            obj.dispatchEvent(new CustomEvent(name));
                            running = false;
                        });
                    };
                    obj.addEventListener(type, func);
                };
                throttle('resize', 'optimizedResize');
            })();
            window.addEventListener('optimizedResize', setVH);
        }
    }
};
</script>

<style lang="scss">
/* import npm styles (if needed) */
@import '~poly-fluid-sizing';

/* import fonts (only in App.vue) */
@import 'assets/css/fonts.scss';

/* import vars (repeat in all .vue files) */
@import 'assets/css/vars.scss';

/* reduce motion */
@media (prefers-reduced-motion: reduce) {
    * {
        animation: none !important;
        transition: none !important;
    }
}

/* start animation when js loaded */
body.js-loading *,
body.js-loading *::before,
body.js-loading *::after {
    animation-play-state: paused !important;
}

html {
    scroll-behavior: smooth;

    @media (prefers-reduced-motion: reduce) {
        scroll-behavior: auto;
    }
}

/* main styles */
body {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    text-rendering: optimizeLegibility;
    font-family: var(--font-main);
    font-weight: 400;
    font-size: 20px;
    line-height: 1.4;
    background: var(--color-main-bg);
    color: var(--color-main-text);

    $mapFontSize: (
        320px: 12px,
        1920px: 20px
    );
    @include poly-fluid-sizing('font-size', $mapFontSize);
}

.main {
    position: relative;
    margin: 0;
    padding-top: constant(safe-area-inset-top);
    padding-right: constant(safe-area-inset-right);
    padding-bottom: constant(safe-area-inset-bottom);
    padding-left: constant(safe-area-inset-left);
}

.controls {
    position: fixed;
    bottom: 3vh;
    right: var(--width-grid-right);
    z-index: 1;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    padding: 0;

    @media (--viewport-tablet) {
        bottom: auto;
        top: 0;
        right: var(--width-grid-gap-mobile);
        height: 50px;
    }

    &[data-chapter='chapterone'] {
        .share {
            &__item {
                color: var(--color-accent-1);

                @media (--viewport-tablet) {
                    color: var(--color-main-text);
                }
            }
        }
    }

    &[data-chapter='chaptertwo'] {
        .share {
            &__item {
                color: var(--color-accent-2);

                @media (--viewport-tablet) {
                    color: var(--color-main-text);
                }
            }
        }
    }

    &[data-chapter='chapterthree'] {
        .share {
            &__item {
                color: var(--color-accent-3);

                @media (--viewport-tablet) {
                    color: var(--color-main-text);
                }
            }
        }
    }
}
</style>
